import EA from '../helpers/init';

export default EA.Methods.newsletterFormSubmitHandler = ($this) => {
    const form = $this;
    const mailInput = form.querySelector('input[type="mail"]');
    const consentInput = form.querySelector('input[type="checkbox"]');
    const submitButtons = form.querySelectorAll('button[type="submit"]');
    const errorMessage = form.querySelector('.error-message');
    const thankYouMessage = form.parentNode.querySelector('.thank-you-message');

    const isDev = import.meta.env.MODE === 'development';
    let restBase = `${window.location.origin}/wp-json/`;

    if(isDev) {
        restBase = `${window.location.origin}/meddox/wp-json/`;
    } else {
        restBase = `${window.location.origin}/wp-json/`;
    }

    const setLoading = (isLoading) => {
        submitButtons.forEach(button => {
            button.disabled = isLoading;
        });
    };

    const showError = (message) => {
        errorMessage.textContent = message;
        errorMessage.classList.add('show');
    };

    const clearError = () => {
        errorMessage.textContent = '';
        errorMessage.classList.remove('show');
    };

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        clearError();

        if(!mailInput.value) {
            showError('Molimo unesite e-mail adresu.');
            return;
        }

        if(!consentInput.checked) {
            showError('Molimo prihvatite politiku privatnosti.');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${restBase}wp/ea/newsletter/subscribe`, {
                method: 'POST',
                body: new URLSearchParams({
                    email: mailInput.value,
                    privacy_policy: consentInput.checked,
                }),
            });

            if(response.status === 409) {
                showError('Korisnik je već pretplaćen.');
                return;
            }

            if(!response.ok) {
                throw new Error('Server error: ', response.status);
            }

            const data = await response.json();
            console.log('Success: ', data);

            form.style.display = 'none';
            thankYouMessage.style.display = 'block';
        } catch(error) {
            showError('Došlo je do greške. Molimo pokušajte ponovno.');
            console.error('Subscription failed: ', error);
        } finally {
            setLoading(false);
        }
    });
};